import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/MarketWatch/MarketWatchComponent.tsx");
